import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Icon from '@/components/Icon.vue';
import { addToken } from '@/helpers/blockchain-utils';
import { bluesAddress, bluesDecimals } from '@/envinroment';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const bluesTokenParams = {
  address: bluesAddress,
  symbol: 'BLUES',
  decimals: bluesDecimals,
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "button-control button-control_gray",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(addToken)(bluesTokenParams)))
  }, [
    _createVNode(Icon, {
      name: "add",
      size: "12"
    }),
    _createVNode(Icon, {
      name: "metamaskFox",
      size: "16"
    })
  ]))
}
}

})